import React from 'react';
import { Toast } from './Toast';
import { CONFIG } from '../../config/mainConfig';

const ImageCreditsLimitPopup = ({}) => {
  return (
    <div className="flex flex-col text-storyblackText font-sofiaSans max-w-xs sm:max-w-md">
      <p className="mb-4 sm:mb-6 text-sm sm:text-base">
        You have reached your monthly limit of image generation credits.
      </p>
      <p className="mb-4 sm:mb-6 text-secondaryStoryBlackGrayText text-sm sm:text-base">
        If you believe this is a mistake or require more credits urgently, please contact our support team and we’ll be
        happy to help.
      </p>
      <div className="flex flex-col sm:flex-row sm:items-end gap-2 sm:gap-0">
        <div className="flex flex-col">
          <span className="text-sm sm:text-base">Email us at:</span>
          <span className="font-black text-sm sm:text-base">{CONFIG.ADMIN_EMAIL_ADDRESS}</span>
        </div>
        <button
          onClick={() => {
            navigator.clipboard.writeText(CONFIG.ADMIN_EMAIL_ADDRESS).then(() => {
              Toast('Email copied successfully', false);
            });
          }}
          aria-label="Copy"
          title="Copy email address"
          className="hover:opacity-80 transition-opacity bg-[#f5f5f4] rounded-lg p-1 sm:ml-4 self-start sm:self-auto"
        >
          <img src="/controls/copy-text-icon.png" alt="" className="w-5 sm:w-6" />
        </button>
      </div>
    </div>
  );
};

export default ImageCreditsLimitPopup;
